import _ from "lodash";
import { v4 as uuidV4 } from "uuid";

import { ACCEPT_UPLOAD_LIST } from "@static/ACCEPT_UPLOAD_LIST";
const DEFAULT_IMAGE_DURATION = 15;

const getVideoDuration = (file) => {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement("video");

    video.src = url;
    video.onloadedmetadata = () => {
      const duration = Math.round(video.duration);
      URL.revokeObjectURL(url);
      resolve(duration);
    };

    video.onerror = () => {
      reject("Error in loading video metadata.");
    };
  });
};

export const generateDragMultipleUpload = ({
  customer_id,
  location_id,
  setFileList = () => undefined,
}) => {
  const uploadMultipleProps = {
    name: "file",
    multiple: true,
    accept: ACCEPT_UPLOAD_LIST,
    beforeUpload: async (file) => {
      const fileName = _.get(file, ["name"]);
      const fileType = _.get(file, ["type"]);
      const fileSize = _.get(file, ["size"]);
      const fileKey = uuidV4();
      const extension = _.chain(fileName).split(".").last().value();
      const isImage = _.includes(["jpg", "jpeg", "png", "gif"], extension);
      const duration = isImage
        ? DEFAULT_IMAGE_DURATION
        : await getVideoDuration(file);

      const uploadFile = {
        category_customer_id: customer_id,
        location_id,
        display_name: fileName,
        extension: extension,
        type: fileType,
        duration,
        size: fileSize,
        file,
        thumbnailFile: null,
        fileKey: fileKey,
      };
      setFileList((prevList) => [...prevList, uploadFile]);
      return false;
    },
  };
  return uploadMultipleProps;
};
